import React from "react";
import styles from "./NavbarAdminLealtad.module.css";
import logo2 from "../../Lealtad/assets/logo/logo2.png";
import { Link } from "react-router-dom";

const NavbarAdminLealtad = () => {
  return (
    <nav className={styles.navbarlealtad}>
      <div className={styles.logolealtad}>
        <Link to="/portal-admin-proveedor-lealtad/inicio">
          <img src={logo2} alt="logo" />
        </Link>
      </div>
    </nav>
  );
};

export default NavbarAdminLealtad;
